import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth-interceptor';

const VoxorTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eef4ff',
      100: '#d9e6ff',
      200: '#b7cdff',
      300: '#85a7ff',
      400: '#5275ff',
      500: '#0029f5',
      600: '#0022cc',
      700: '#001b9e',
      800: '#0b1e8d',
      900: '#000b3d',
      950: '#000627',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#0029f5',
          contrastColor: '#ffffff',
          hoverColor: '#0022cc',
          activeColor: '#001b9e',
        },
        highlight: {
          background: 'rgba(22, 223, 253, 0.18)',
          focusBackground: 'rgba(22, 223, 253, 0.28)',
          color: '#000b3d',
          focusColor: '#000b3d',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    providePrimeNG({
      ripple: true,
      inputVariant: 'filled',
      theme: {
        preset: VoxorTheme,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
    MessageService,
    ConfirmationService,
  ],
};
